import moment from 'moment';

import { Interval } from '@packlink/packlink-sdk';

export interface ICollectionDateSelectOption {
    label: string;
    value: string;
}

export interface ICollectionDateForm {
    intervals?: Interval[];
    selectOption: ICollectionDateSelectOption;
}

export interface ICollectionState {
    date: moment.Moment | null;
    interval: string | null;
}

export const COLLECTION_DATE_FORMAT = 'ddd Do MMM';
